// The docs' snippets as CodeTabs' tabs (the console's: snippets come from the docs pages through
// the docsBlocks Vite plugin, so this stays here while CodeTabs lives in @apsio/ui).
import type { CodeTab } from '@apsio/ui'
import type { ReactNode } from 'react'
import type { DocSnippet } from '../../lib/docSnippets'

/** A line of code, its comments and strings marked as CodeTabs' callers mark them. */
function CodeLine({ line }: { line: string }) {
  if (/^\s*(\/\/|#)/.test(line)) return <span className="cm">{line}</span>
  const parts = line.split(/("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s\/\/ .*$|\s# .*$)/)
  return (
    <>
      {parts.map((p, i) =>
        /^["']/.test(p) ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: a fixed split of one line
          <span key={i} className="s">
            {p}
          </span>
        ) : /^\s(\/\/|#) /.test(p) ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: a fixed split of one line
          <span key={i} className="cm">
            {p}
          </span>
        ) : (
          p
        ),
      )}
    </>
  )
}

/** The docs' snippets as CodeTabs' tabs: the code marked, Copy with the code as written. */
export const docTabs = (snippets: DocSnippet[], note?: (s: DocSnippet) => ReactNode): CodeTab[] =>
  snippets.map((x) => ({
    id: x.id,
    label: x.label,
    note: note?.(x),
    copy: x.copy ?? x.code,
    code: x.code.split('\n').map((line, i) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: fixed lines
      <span key={i}>
        <CodeLine line={line} />
        {'\n'}
      </span>
    )),
  }))
